import { action, makeObservable, observable } from "mobx";
import config from "../config";
import { postApi } from "../components/Utility";

class RevenueCollectionStore {
    loading = false;
    total = 0;
    driverRevenueData = []
    taxiTripsData = []
    tripPhotoFromDb = []
    paymentPhotoFromDb = []
    rootStore;

    constructor(rootStore) {
        makeObservable(this, {
            loading: observable,
            total: observable,
            driverRevenueData: observable,
            taxiTripsData: observable,
            tripPhotoFromDb: observable,
            paymentPhotoFromDb: observable,

            addRevenueData: action,
            getDriverRevenueData: action,
            getShiftsData: action,
            updateTripsData: action,
            addPaymentChangeData: action,
            setProofForTripVoid: action,
            setProofForChangePayment: action
        });
        this.rootStore = rootStore;
    }

    async getShiftsData(driverId) {
        this.loading = true
        var postData = {
            driverId: driverId,
        };

        var response = await postApi
            .getClient()
            .get(config.NodeUrl + "/cashier/getShiftData", {
                params: postData,
            });

        this.shiftsData = response?.data?.shiftsData

        this.loading = false
        return response?.data?.shiftsData
    }

    async getDriverRevenueData(shiftId) {
        this.loading = true
        var postData = {
            shiftId: shiftId,
        };

        var response = await postApi
            .getClient()
            .get(config.NodeUrl + "/cashier/getDriverRevenueInfo", {
                params: postData,
            });

        this.driverRevenueData = response?.data?.driverRevenuedata

        this.loading = false
        return response?.data?.driverRevenuedata
    }

    async addRevenueData(postData) {
        var revenueData = { postData };

        var response = await postApi
            .getClient()
            .post(config.NodeUrl + "/cashier/saveRevenueData", revenueData);

        return response.data;
    }

    async showTripsData({ shiftId, driverId }) {
        this.loading = true
        var postData = {
            shiftId: shiftId,
            driverId: driverId
        };

        var response = await postApi
            .getClient()
            .get(config.NodeUrl + "/cashier/getTaxiTripsInfo", {
                params: postData,
            });

        this.taxiTripsData = response?.data?.tripsData

        this.loading = false
        return response?.data?.tripsData
    }

    async updateTripsData(postData) {
        var tripData = { postData };

        var response = await postApi
            .getClient()
            .post(config.NodeUrl + "/cashier/updateTripsData", tripData);

        return response.data;
    }

    async addPaymentChangeData(postData) {
        var paymentData = { postData };

        var response = await postApi
            .getClient()
            .post(config.NodeUrl + "/cashier/savePaymentChangeData", paymentData);

        return response.data;
    }

    async setProofForTripVoid(photo) {
        this.tripPhotoFromDb = { fileList: photo };
    }

    async setProofForChangePayment(photo) {
        this.paymentPhotoFromDb = { fileList: photo };
    }

    async getPaymentQRData(shiftId) {
        this.loading = true
        var postData = {
            shiftId: shiftId,
        };

        var response = await postApi
            .getClient()
            .get(config.NodeUrl + "/cashier/getPaymentQRData", {
                params: postData,
            });

        this.qrCodeData = response?.data?.paymentData

        this.loading = false
        return response?.data?.paymentData
    }

    async recalulateTripsData({ shiftNo, driverId, shiftId }) {
        this.loading = true
        var postData = {
            shiftId: shiftId,
            driverId: driverId
        };

        var response = await postApi
            .getClient()
            .get(config.NodeUrl + "/cashier/recalulateTripsData", {
                params: postData,
            });

        this.recalculateTripsData = response?.data?.tripsData

        this.loading = false
        return response?.data?.tripsData
    }

    async updateShiftsData(data) {

        var response = await postApi
            .getClient()
            .post(config.NodeUrl + "/cashier/updateShiftsData", data);

        return response.data;
    }
}
export default RevenueCollectionStore;